import { config } from '../config';

let $container = $('.card-list');

const init = () => {
  enquire.register(`screen and (max-width: ${config.breakpoint.xsMax}px)`, {
    match() {
      _initIconCarousel();
    },
    unmatch() {
      _destroyIconCarousel();
    }
  });
};

const _initIconCarousel = () => {
  $container.slick({
    dots: true,
    arrows: false
  });
};

const _destroyIconCarousel = () => {
  $container.slick('destroy');
};


export { init }